import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class LicenciaService {

  licencia: any

  constructor() { }

  getAllLincencias(){
    return gql`
      query getAllLicencias {
          licencias(sort: "createdAt:DESC") {
            IDCentro
            IDContratista
            IDCLiente
            fechaConfirmacion
            IDLicencia
            licenciaActiva
            fechaCaducidad
            precio
          }
        }
    `;
  }

  getLicenciaById(){
    return gql`
      query getLicenciaById($id: ID!) {
          licencia(id: $id) {
            IDCentro
            IDContratista
            IDCLiente
            fechaConfirmacion
            IDLicencia
            licenciaActiva
            fechaCaducidad
            precio
          }
        }
    `;
  }

  getLicenciasByContratista(){
    return gql`
      query getLicenciasByContratista($id: ID!){
        contratista(id: $id){
          licencias {
            id
            IDLicencia
            fechaCaducidad
            fechaConfirmacion
            fechaRenovacion
            centro{
              nombre
            }
            cliente{
              nombreComercial
            }
            contratista {
              nombreComercial
              contactoResponsable {
                mail
              }
            }
            
          }
        }
      }
    `;
  }

  getLicenciasByCliente(){
    return gql`
      query getLicenciasByCliente($id: ID!){
        cliente(id: $id){
          licencias {
            id
            IDLicencia
            fechaCaducidad
            fechaConfirmacion
            licenciaActiva
            centro{
              nombre
            }
            cliente{
              nombreComercial
            }
            
          }
        }
      }
    `;
  }

  addLicencia(){
    return gql`
      mutation createLicencia($input: createLicenciaInput!) {
      createLicencia(input: $input) {
        licencia {
          id
        }
      }
    }
    `;
  }

  updateLicencia(){
    return gql`
      mutation updateLicencia($input: updateLicenciaInput!) {
        updateLicencia(input: $input) {
          licencia {
            id
          }
        }
      }
    `;
  }

  deleteLicencia(){
    return gql`
      mutation deleteLicencia($input: deleteLicenciaInput!) {
        deleteLicencia(input: $input) {
          licencia {
            id
          }
        }
      }
    `;
  }

  setLicencia(licencia:any){
    this.licencia = licencia; 
  }

  getLicencia(){
   let temp = this.licencia;
    this.clearLicencia();
    return temp;
  }

  clearLicencia(){
    this.licencia = undefined;
  }
}
